import { render, staticRenderFns } from "./SettingsProvider.vue?vue&type=template&id=72d58b34&lang=pug&"
import script from "./SettingsProvider.vue?vue&type=script&lang=js&"
export * from "./SettingsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports